import { globalErrorsEn } from '@/shared/locales/globalErrors';
import { referenceErrorsEn } from '@/shared/locales/referenceErrors';
import accountCenter from './en-US/accountCenter';
import alerts from './en-US/alerts';
import component from './en-US/component';
import drama from './en-US/drama';
import global from './en-US/global';
import globalHeader from './en-US/globalHeader';
import ledger from './en-US/ledger';
import menu from './en-US/menu';
import notification from './en-US/notification';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import team from './en-US/team';
export default {
  'canvasOps.video.play': 'Play',
  'canvasOps.video.pause': 'Pause',
  'canvasOps.preview.download': 'Download',
  'canvasOps.preview.noVideo': 'No video',
  'canvasOps.preview.noImage': 'No image',
  'canvas.common.close': 'Close',
  'canvas.aiToolbar.previewZoom': 'Preview',
  'canvas.refs.unavailable.video': 'Video unavailable',
  'canvas.refs.unavailable.image': 'Image unavailable',
  'canvasOps.preview.downloadFailed': 'Download failed. Try again.',

  'canvasOps.video.fullscreen': 'Fullscreen',
  'canvasOps.video.exitFullscreen': 'Exit fullscreen',

  'canvasOps.video.unmute': 'Click to unmute',
  'canvasOps.video.mute': 'Click to mute',
  ...referenceErrorsEn,
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...notification,
  ...accountCenter,
  ...drama,
  ...global,
  ...team,
  ...ledger,
  ...alerts,
  ...globalErrorsEn,
};
